// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const Add: React.FC = () => {
    return <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48"  strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" focusable="false" width="24" height="24" fill="currentColor"><path d="M46.2 22.5H25.5V1.8c0-.9-.7-1.5-1.5-1.5s-1.6.7-1.6 1.5v20.7H1.8c-.9 0-1.5.7-1.5 1.5s.7 1.5 1.5 1.5h20.7v20.7c0 .9.7 1.5 1.5 1.5s1.5-.7 1.5-1.5V25.6h20.7c.9 0 1.5-.7 1.5-1.5s-.6-1.6-1.5-1.6z"/></svg>;
};

export default React.memo(Add);
